import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// Fires a "visit" beacon whenever the URL path changes. Silent no-op on failure.
export default function VisitorTracker() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (path.startsWith("/payment/")) return; // don't log return-from-Stripe URLs with session_id
    api.post("/track/visit", {
      path,
      referrer: document.referrer || "",
      screen: `${window.screen?.width || 0}x${window.screen?.height || 0}`,
      lang: navigator.language || "",
    }).catch(() => { /* silent */ });
  }, [location.pathname, location.search]);
  return null;
}
